<template>
    <div id="index" v-cloak>
        <div class="visible-xs min_index">
            <header class="flex_center m_header">
                <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
                <h4 class="header_title">设置</h4>
            </header>
            <!-- 内容 -->
            <div class='setUp_center'>
                <div class="setUp_div">
                    <div class="setUp_li flex_between">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">密码</span>
                            <span class="li_text">******</span>
                        </div>
                        <span class="li_right" @click.stop="forget">修改密码</span>
                    </div>
                    <div class="setUp_li flex_between">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">绑定手机</span>
                            <span class="li_text">{{user.mobile}}</span>
                        </div>
                        <span class="li_right" @click.stop="dindingFun">更换手机</span>
                    </div>
                    <div class="setUp_li flex_between wx_button">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">第三方绑定</span>
                            <span class="li_text flex_center" @click.stop="no_dindingWX" v-if="user.unionid">
                                <i><img :src="user.headimage" alt=""></i>
                                <a href="javaScript:void(0)">解除绑定</a>
                            </span>
                        </div>
                        <span class="li_right" v-if="!user.unionid || user.unionid == ''"
                            @click.stop="dindingWX">绑定微信</span>
                    </div>
                </div>
                <div class="setUp_div">
                    <h5 class="setUp_title">联系我们</h5>
                    <div class="setUp_li flex_between">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">联系电话</span>
                            <span class="li_text">021-50832011</span>
                        </div>
                        <!-- <i class="li_right">
                            <img src="@/assets/img/rigth_hui.png" alt="">
                        </i> -->
                    </div>
                    <div class="setUp_li flex_between">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">联系邮箱</span>
                            <span class="li_text">xuzhi@anesthesiavision.cn</span>
                        </div>
                        <!-- <i class="li_right">
                            <img src="@/assets/img/rigth_hui.png" alt="">
                        </i> -->
                    </div>
                </div>
                <div class="setUp_div button_div">
                    <!-- <div class="setUp_li flex_between">
                        <div class="li_left flex_start flex_items">
                            <span class="li_title">退出登录</span>
                            
                        </div>
                        <i class="li_right">
                            <img src="@/assets/img/rigth_hui.png" alt="">
                        </i>
                    </div> -->
                    <el-button class="exitLogin" @click="removeFun" type="danger">退出登录</el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "index",
        data() {
            return {
                user: {},//用户信息
            };
        },
        computed: {},
        components: {

        },
        watch: {

        },
        methods: {
            no_dindingWX() {//解除绑定
                let that = this;
                layer.open({
                    content: '您确定要解除微信绑定吗？'
                    , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
                    , btn: ['确定', '取消']
                    , yes: function (index) {
                        layer.close(index);
                        that.$post('rebind', {
                            member_id: that.USER().id,
                        }).then(res => {
                            layer.open({
                                content: '解绑成功'
                                , time: 1
                                , skin: 'msg'
                            });
                            that.user = res.data;
                        })

                    }
                });
            },
            dindingWX() {//微信绑定
                let that = this;
                if (this.$store.state.is_app) {
                    android.loginWx();
                } else {
                    this.GET_Token({
                        type: 2,
                        success: function (res) {
                            if (res) {
                                layer.open({
                                    content: "绑定成功！",
                                    time: true,
                                    skin: "msg"
                                })
                                that.getUser();
                            }
                        }
                    })
                }

            },
            dindingFun() {
                this.$store.commit('setPhone', '');
                this.$router.replace({ path: '/m_binding', query: { url: this.$route.path } });
            },
            forget() {//修改密码
                this.$store.commit('setPhone', this.USER().mobile);
                this.$router.replace({ path: '/m_forget', query: { url: this.$route.path } });
            },
            removeFun() {//退出登录
                let that = this;
                layer.open({
                    content: '您确定要退出登录吗？'
                    , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
                    , btn: ['确定', '取消']
                    , yes: function (index) {
                        // location.reload();
                        layer.close(index);
                        that.REMOVE_USER();
                        layer.open({
                            content: '退出成功'
                            , time: 1
                            , skin: 'msg'
                        });
                        setTimeout(() => {
                            that.$router.replace("/");
                        }, 1000)
                    }
                });
            },
            goBackward() {//返回上一页
                this.$router.replace({ path: '/m_my' });
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();
                that.user = this.USER();
            },


        },
        mounted() {


            this.getUser();
            this.getShare();
            if (this.GetRequest().code) {
                this.GET_Token();
            }
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }

        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;

    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        background: #F7FAFC;
        padding-bottom: 0 !important;
    }

    /* 内容 */
    .setUp_center {}

    .setUp_center .setUp_div {
        margin-bottom: 1.5rem;
        padding-left: 1.5rem;
        background: #fff;

    }

    .setUp_center .setUp_div .setUp_title {
        font-size: 1.8rem;
        font-weight: bold;
        color: #333;
        padding: 1.6rem 0 .6rem 0;
    }

    .setUp_center .setUp_div .setUp_li {
        border-bottom: .05rem solid rgba(223, 223, 223, .8);
        height: 5rem;
        padding: 0 1.6rem 0 0;
    }

    .setUp_center .setUp_div:last-child {
        margin: 0;
    }

    .setUp_li .li_left .li_title {
        min-width: 6rem;
        font-size: 1.4rem;
        color: #333;
        margin-right: 1.4rem;
        display: block;
    }

    .setUp_li .li_left .li_text {
        font-size: 1.4rem;
        color: #666;
    }

    .setUp_li .li_right {
        color: #F24D5B;
    }

    .setUp_li i.li_right {
        width: 1rem;
    }

    .wx_button .li_text>i {
        width: 2.4rem;
        margin-right: 1.4rem;
        border-radius: 50%;
        overflow: hidden;
    }

    .wx_button .li_text>a {
        font-size: 1.4rem;
        color: #333;
    }

    .button_div {
        padding-top: 4rem;
    }

    .exitLogin {
        margin: 0 auto;
        display: block;
        width: 70%;
        height: 4.5rem;
        font-size: 1.8rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_setUp.vue